import { withMask, withIcon, withLabel } from '../enhancers';
import Input from '../views/Input';


export default withLabel(withIcon(withMask(Input)));
